var render = function render(){var _vm=this,_c=_vm._self._c;return _c('builder',{attrs:{"data":_vm.page.layoutPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }